import { render, staticRenderFns } from "./Workmanage.vue?vue&type=template&id=32d312b9&scoped=true&"
import script from "./Workmanage.vue?vue&type=script&lang=ts&"
export * from "./Workmanage.vue?vue&type=script&lang=ts&"
import style0 from "./Workmanage.vue?vue&type=style&index=0&id=32d312b9&lang=scss&scoped=true&"
import style1 from "./Workmanage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d312b9",
  null
  
)

export default component.exports